/** @format */

import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { LastCreatedCaseNo } from 'src/app/state-management';

@Component({
	selector: 'app-addcase-confirmation',
	templateUrl: './addcase-confirmation.component.html',
	styleUrls: ['./addcase-confirmation.component.css'],
	standalone: false,
})
export class AddcaseConfirmationComponent implements OnInit {
	@Input() newProblem: LastCreatedCaseNo;
	@Input() isTransferringToCityworks: boolean;
	@Output() outPutNewCase = new EventEmitter<number>();

	constructor() {}

	ngOnInit() {}

	forwardNewCase(gotoStep: number) {
		this.outPutNewCase.emit(gotoStep);
	}
}
